import * as React from 'react';

function Error({message}: {message: string}) {
  return (
      <p className="border p-3 bg-yellow-400 text-center rounded">{message}</p>
  );
}

export default Error;
